import React from 'react';
import { styled } from '@mui/material/styles';
import { Fade } from '@mui/material';
import Introduction from './components/psg-conf-2025/Introduction';
import PSGConferenceForm from '../../components/forms/PSGConferenceForm';

const PSGConferenceRoot = styled('div')(({ theme }) => ({}));

const PSGConference = () => {
    return (
        <Fade in={true}>
            <PSGConferenceRoot>
                <Introduction />

                <PSGConferenceForm source="person" />
            </PSGConferenceRoot>
        </Fade>
    );
};

export default PSGConference;
